export const article = {
  title: "Gdzie mogę sprawdzić, ile punktów posiadam?",
  date: "11 czerwiec 2019, at 10:46 am",
  content:
    "<p>Informacja na temat ilości posiadanych punktów dostępna jest po zalogowaniu się do Kafeterii MyBenefit, w górnym prawym rogu strony, w sekcji Twoje punkty. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p> <img src='https://feniks-pwa.g4n.eu/media/generator/modules/s/c/screenshot_71621886009679091.png'/> <p>Twoje punkty. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p>",
};
export const linksArticles = [
  {
    title: "Gdzie mogę sprawdzić, ile punktów posiadam?",
    url: "/",
  },
  {
    title:
      "W jaki sposób mogę spawdzić ile punktów zostało do tej lorem ipsum dolor sit amet",
    url: "/",
  },
  {
    title: "Czy mogę sprawdzić, ile punktów posiadam?",
    url: "/",
  },
  {
    title: "Gdzie mogę sprawdzić, ile punktów posiadam?",
    url: "/",
  },
  {
    title:
      "W jaki sposób mogę spawdzić ile punktów zostało do tej lorem ipsum dolor sit amet",
    url: "/",
  },
  {
    title: "Czy mogę sprawdzić, ile punktów posiadam?",
    url: "/",
  },
  {
    title: "Gdzie mogę sprawdzić, ile punktów posiadam?",
    url: "/",
  },
  {
    title:
      "W jaki sposób mogę spawdzić ile punktów zostało do tej lorem ipsum dolor sit amet",
    url: "/",
  },
  {
    title: "Czy mogę sprawdzić, ile punktów posiadam?",
    url: "/",
  },
  {
    title: "Gdzie mogę sprawdzić, ile punktów posiadam?",
    url: "/",
  },
  {
    title:
      "W jaki sposób mogę spawdzić ile punktów zostało do tej lorem ipsum dolor sit amet",
    url: "/",
  },
  {
    title: "Czy mogę sprawdzić, ile punktów posiadam?",
    url: "/",
  },
  {
    title: "Gdzie mogę sprawdzić, ile punktów posiadam?",
    url: "/",
  },
];
